import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {PrincipalService} from '../services/principal/principal.service';

@Directive({selector: '[appHasAnyAuthority]'})
export class HasAnyAuthorityDirective {
  private authorities: string[];

  constructor(private principal: PrincipalService,
              private templateRef: TemplateRef<any>,
              private viewContainerRef: ViewContainerRef) {
  }

  @Input()
  set appHasAnyAuthority(value: string | string[]) {
    this.authorities = typeof value === 'string' ? [value as string] : value as string[];
    this.updateView();
    // Get notified each time authentication state changes.
    this.principal.getAuthenticationState().subscribe(() => this.updateView());
  }

  private updateView(): void {
    this.principal.hasAnyAuthority(this.authorities).subscribe(result => {
      this.viewContainerRef.clear();
      if (result) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    });
  }
}
